module.exports = __webpack_public_path__ + "fonts/font.ffa13e6.woff";